import { useParams } from "react-router-dom";
import { MuiPage } from "../../../components";
import { MuiAccordionArray } from "../../../components/MuiAccordionArray";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import RoleEdit from "./role.edit";
import { RoleApplicationMapping } from "./roleAccordian/roleApplicationMapping";
import { RoleFeatureMapping } from "./roleAccordian/roleFeatureMapping";
import { RoleModuleMapping } from "./roleAccordian/roleModuleMapping";
import { RoleUserMapping } from "./roleAccordian/roleUserMapping";

export const RoleAddEdit = () => {
    const { id: RoleId } = useParams();
    const ApplicationId = getLocalStorageItem('ApplicationId')

    const accordionArray = [
        {
            panelId: 'Panel1',
            name: ("User"),
            child: <RoleUserMapping request={{ RoleId, ApplicationId }} />
        },
        {
            panelId: 'Panel2',
            name: ("Application"),
            child: <RoleApplicationMapping request={{ RoleId, ApplicationId }} />
        },
        {
            panelId: 'Panel3',
            name: ("Modules"),
            child: <RoleModuleMapping request={{ RoleId, ApplicationId }} />
        },
        {
            panelId: 'Panel4',
            name: ("Feature"),
            child: <RoleFeatureMapping request={{ RoleId, ApplicationId }} />
        }
    ]

    return (
        <MuiPage>
            <RoleEdit />
            {!!RoleId && (
                <MuiAccordionArray
                    accordionArray={accordionArray}
                />
            )}
        </MuiPage>
    );
}